import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { mutationKeys } from '../mutationKeys';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { ContactTemplate } from '../../../types/ContactTemplate';

export const updateContactTemplate = async (uuid: string, formData: ContactTemplate) => {
  const response = await CustomAxios.put(`contact_templates/${uuid}`, formData);
  return response.data;
};

interface UseUpdateContactTemplateProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useUpdateContactTemplate({ uuid, onSuccessCallback }: UseUpdateContactTemplateProps) {
  return useMutation({
    mutationKey: [mutationKeys.updateContactTemplate],
    mutationFn: (formData: ContactTemplate) => updateContactTemplate(uuid, formData),
    onSuccess: (data: ContactTemplate) => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allContactTemplates, data.uuid],
      });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const template = err.response.data as ContactTemplate;
        queryClient.setQueryData([queryKeys.allContactTemplates, template.uuid], template);
      }
    },
  });
}
